$(function () {
  // Initialize on page (re-)load
  document.addEventListener('Neos.PageLoaded', function(event) {
    Youtube.initializeYoutubeVideo();
  }, false);

  const youtubeConsentElements = document.querySelectorAll('.youtube-playlist-privacy');

  for (let youtubeConsent of youtubeConsentElements) {
    if (sessionStorage.getItem("youtubeConsent")) {
      youtubeConsent.remove();
      Youtube.initializeYoutubeVideo();
    } else {
      const consentButton = youtubeConsent.querySelector('button');
      consentButton.addEventListener('click', (event) => {
        const youtubeContainer = event.target.parentNode.nextElementSibling;
        if (youtubeContainer && youtubeContainer.classList.contains('youtube-playlist')) {
          sessionStorage.setItem("youtubeConsent", "true");
          youtubeConsent.remove();
          Youtube.initializeYoutubeVideo();
        }
      })
    }
  }
});

var Youtube = {

    initializeYoutubeVideo: function () {
        const youtubeContainers = document.querySelectorAll('.youtube-playlist');

        if (sessionStorage.getItem("youtubeConsent") && youtubeContainers.length) {
            for (let youtubeContainer of youtubeContainers) {
              const teaserVideoRow = youtubeContainer.querySelector('.youtube-playlist-teaser');
              const teaserVideoContainer = teaserVideoRow.querySelector('.video-item');
              const videoTemplate = youtubeContainer.querySelector('.teaser-video-template');
              if (videoTemplate) {
                const videoLink = videoTemplate.getAttribute('data-video-link');

                const videoWrapper = document.createElement('div');
                videoWrapper.classList.add('embed-responsive');
                videoWrapper.classList.add('embed-responsive-16by9');

                const iframe = document.createElement('iframe');
                iframe.classList.add('embed-responsive-item')
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allowfullscreen', 'true');
                iframe.setAttribute('src', videoLink);

                videoWrapper.appendChild(iframe);
                teaserVideoContainer.appendChild(videoWrapper);

                videoTemplate.remove();
              }

              const videoItemsContainer = youtubeContainer.querySelector('.youtube-playlist-items');
              if (videoItemsContainer) {
                const videoItems = videoItemsContainer.querySelectorAll('.video-item');
                for (let videoItem of videoItems) {
                  const videoItemTemplate = videoItem.querySelector('.video-item-template');
                  const videoLink = videoItemTemplate.getAttribute('data-video-link');

                  const videoItemWrapper = document.createElement('div');
                  videoItemWrapper.classList.add('embed-responsive');
                  videoItemWrapper.classList.add('embed-responsive-16by9');

                  const iframe = document.createElement('iframe');
                  iframe.classList.add('embed-responsive-item')
                  iframe.setAttribute('frameborder', '0');
                  iframe.setAttribute('allowfullscreen', 'true');
                  iframe.setAttribute('src', videoLink);

                  videoItemWrapper.appendChild(iframe);
                  videoItem.appendChild(videoItemWrapper);

                  videoItemTemplate.remove();
                }
              }
            }
        }
    }
}
